/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPmiFeatureControl = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M5.506 17.005V6.827h6.328v1.484H7.256v3.052h4.088v1.484H7.256v4.158h-1.75zm12.988-1.665v1.385c-.289.14-.63.247-1.022.322a5.867 5.867 0 0 1-1.232.126c-2.342 0-3.514-1.311-3.514-3.934 0-1.195.313-2.119.938-2.772.635-.653 1.526-.98 2.674-.98.738 0 1.386.126 1.946.378v1.372a3.546 3.546 0 0 0-1.624-.406c-1.474 0-2.212.803-2.212 2.408 0 .877.168 1.526.504 1.946.346.42.868.63 1.568.63.56 0 1.218-.159 1.974-.476z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgPmiFeatureControl as PmiFeatureControl };
